module.exports = __webpack_public_path__ + "static/media/planning.59236296.png";